import { useState } from 'react';
import { Pencil, Plus, Share2 } from 'lucide-react';
import { noteName, findInstrument } from '@/lib/pitch';
import { TuningEditor } from '@/components/tuner/TuningEditor';
import QRShareModal from '@/components/QRShareModal';
import { buildTuningShareUrl } from '@/lib/tuningShare';

const iconBtn = 'h-11 w-11 shrink-0 rounded-xl border border-white/10 flex items-center justify-center hover:bg-white/5 active:scale-95 transition-transform';
const short = (notes) => notes.map((m) => noteName(m, false).replace(/-?\d+$/, '')).join(' ');

export const TuningPicker = ({ tunings }) => {
  const { instrumentId, presets, counts, custom, tuning, select, save, remove } = tunings;
  const [editor, setEditor] = useState(null); // null | 'new' | tuning
  const [sharing, setSharing] = useState(false);

  return (
    <div className="flex gap-2 mb-3">
      <select
        data-testid="tuner-tuning-select"
        value={tuning.id}
        onChange={(e) => select(e.target.value)}
        className="h-11 min-w-0 flex-1 rounded-xl bg-[#0A0A0A] border border-white/10 px-3 text-sm text-white focus:outline-none focus:border-pink-400"
      >
        <optgroup label="Preset">
          {presets.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
        </optgroup>
        {custom.length > 0 && (
          <optgroup label="Personali">
            {custom.map((t) => <option key={t.id} value={t.id}>{`${t.name} (${short(t.notes)})`}</option>)}
          </optgroup>
        )}
      </select>
      {tuning.custom && (
        <>
          <button data-testid="tuner-tuning-share" aria-label="Condividi accordatura" onClick={() => setSharing(true)} className={`${iconBtn} text-sky-300 border-sky-400/40`}><Share2 className="w-4 h-4" /></button>
          <button data-testid="tuner-tuning-edit" aria-label="Modifica accordatura" onClick={() => setEditor(tuning)} className={iconBtn}><Pencil className="w-4 h-4" /></button>
        </>
      )}
      <button data-testid="tuner-tuning-new" aria-label="Nuova accordatura" onClick={() => setEditor('new')} className={`${iconBtn} text-pink-300 border-pink-400/40`}><Plus className="w-4 h-4" /></button>
      <TuningEditor
        open={editor !== null}
        initial={editor === 'new' ? null : editor}
        counts={counts}
        onClose={() => setEditor(null)}
        onSave={(t) => { save(t); setEditor(null); }}
        onDelete={(id) => { remove(id); setEditor(null); }}
      />
      <QRShareModal
        open={sharing && !!tuning.custom}
        url={tuning.custom ? buildTuningShareUrl(instrumentId, tuning) : ''}
        title={tuning.name}
        subtitle={`${findInstrument(instrumentId).name} · ${short(tuning.notes)}`}
        caption="Scansiona per aggiungere l'accordatura"
        onClose={() => setSharing(false)}
      />
    </div>
  );
};
